export const PRODUCT_WORDMARK = 'BIM–GIS';
export const PRODUCT_REGION = 'An Giang';
export const PRODUCT_BRAND = `${PRODUCT_WORDMARK} ${PRODUCT_REGION}`;
export const PRODUCT_DESCRIPTION =
  'Ứng dụng BIM và GIS trong quản lý, khai thác và bảo trì công trình.';
export const CMS_NAME = 'Hệ thống quản lý công trình BIM–GIS An Giang';
export const CMS_SHORT_NAME = 'Quản lý công trình';
export const VIEW_NAME = 'Bản đồ công trình 3D tỉnh An Giang';
export const VIEW_SHORT_NAME = 'Bản đồ công trình 3D';
